{
  "articles": [
    {
      "author": "FirstDesk",
      "source": {
        "name": "FirstDesk"
      },
      "title": "Native simulator shell baseline restored - FirstDesk",
      "description": "The v2 simulator is moving to a modern desktop shell with FirstDesk state and evaluator adapters.",
      "content": "The v2 simulator shell is now driven by a polished desktop baseline with FirstDesk-owned state bridges.",
      "url": "https://firstdesk.nl",
      "urlToImage": "img/asset/community.jpg"
    },
    {
      "author": "FirstDesk",
      "source": {
        "name": "FirstDesk"
      },
      "title": "Server and cloud-admin profiles available - FirstDesk",
      "description": "Training profiles expose workstation, server and cloud-admin tools through the same native shell.",
      "content": "Server and cloud-admin scenarios use the same shell, command path and evaluator-safe simulator state.",
      "url": "https://firstdesk.nl",
      "urlToImage": "img/asset/server.jpg"
    }
  ]
}
